/** STALE-BUILD-1 (2026-09-24): a lazily loaded section whose code file belongs to a previous
 * deployment. Vercel serves only the current build's assets, so a tab opened before a deploy gets
 * a 404 the first time it opens Market Analytics, Scorecard or Kenteken. Chrome, Safari, Firefox
 * and Vite's CSS preload each word it differently. */
const STALE_BUILD = /dynamically imported module|Importing a module script failed|Unable to preload CSS/i

export const isStaleBuildError = error => STALE_BUILD.test(String(error?.message ?? error ?? ''))
